<script>
  export let icon = null;
  export let items = [];
  export let emptyText = '';
  export let limit = 10;
  export let showMore = false;
  export let renderMode = 'file';
  export let normalizeUrl = (value) => value;
  export let isImage = () => false;
  export let onOpen = () => {};
  export let onToggleMore = () => {};
  export let onContextMenu = () => {};
  export let onTouchStart = () => {};
  export let onTouchEnd = () => {};

  $: visibleItems = showMore ? items : items.slice(0, limit);

  function formatBytes(value = 0) {
    const bytes = Number(value || 0);
    if (!Number.isFinite(bytes) || bytes <= 0) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    let size = bytes;
    let index = 0;
    while (size >= 1024 && index < units.length - 1) {
      size /= 1024;
      index += 1;
    }
    const digits = size >= 10 || index < 2 ? 0 : 1;
    return `${size.toFixed(digits)} ${units[index]}`;
  }
</script>

<div class="px-4 pb-4">
  {#if renderMode === 'media'}
    <div class="grid grid-cols-4 gap-2">
      {#each visibleItems as item (item.id || item.url)}
        <button
          type="button"
          class="relative aspect-square overflow-hidden rounded-md border border-slate-200 bg-slate-100 text-slate-500"
          onclick={() => onOpen(item)}
          oncontextmenu={(event) => onContextMenu(event, item)}
          ontouchstart={(event) => onTouchStart(event, item)}
          ontouchend={onTouchEnd}>
          {#if isImage(item.url, item.mime)}
            <img src={normalizeUrl(item.url)} alt={item.name || 'media'} class="h-full w-full object-cover" />
          {:else}
            <video src={normalizeUrl(item.url)} class="h-full w-full object-cover" muted playsinline preload="metadata"></video>
            <span class="absolute inset-0 bg-black/10"></span>
          {/if}
        </button>
      {/each}
    </div>
  {:else if renderMode === 'link'}
    <div class="space-y-2">
      {#each visibleItems as item (item.id || item.url)}
        <a
          href={normalizeUrl(item.url)}
          target="_blank"
          rel="noreferrer"
          class="flex min-w-0 items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-[12px] text-blue-700 hover:bg-slate-100"
          oncontextmenu={(event) => onContextMenu(event, item)}
          ontouchstart={(event) => onTouchStart(event, item)}
          ontouchend={onTouchEnd}>
          {#if icon}
            <svelte:component this={icon} size={14} class="shrink-0" />
          {/if}
          <span class="truncate">{item.url}</span>
        </a>
      {/each}
    </div>
  {:else}
    <div class="space-y-1">
      {#each visibleItems as item (item.id || item.url)}
        <button
          type="button"
          class="flex w-full min-w-0 items-center gap-2 rounded-lg px-3 py-2 text-left text-[13px] text-slate-700 hover:bg-slate-50"
          onclick={() => onOpen(item)}
          oncontextmenu={(event) => onContextMenu(event, item)}
          ontouchstart={(event) => onTouchStart(event, item)}
          ontouchend={onTouchEnd}>
          {#if icon}
            <svelte:component this={icon} size={15} class="shrink-0 text-slate-400" />
          {/if}
          <span class="min-w-0 flex-1 truncate">{item.name || item.url.split('/').pop()}</span>
          {#if formatBytes(item.size)}
            <span class="shrink-0 text-[11px] text-slate-400">{formatBytes(item.size)}</span>
          {/if}
        </button>
      {/each}
    </div>
  {/if}

  {#if !items.length}
    <p class="rounded-lg bg-slate-50 px-3 py-4 text-center text-[11px] text-slate-500">{emptyText}</p>
  {/if}

  {#if items.length > limit}
    <button
      class="mt-3 w-full rounded-lg bg-slate-200 px-3 py-2 text-[12px] font-semibold text-slate-900 hover:bg-slate-300"
      type="button"
      onclick={onToggleMore}>
      {showMore ? 'Thu gọn' : 'Xem tất cả'}
    </button>
  {/if}
</div>
